/**
PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *  Copyright © 2026 Pearson Education, Inc.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
* */

/**
 * Injects {@code featureFlagsClient} (Harness FME via OpenFeature) for class components.
 *
 * @file withOpenFeatureConsumer.jsx
 * @author Mohamed yasar arabath M
 * @since 1.0.11
 */

import React, { useMemo } from 'react';
import { useOpenFeatureClient } from '@openfeature/react-sdk';
import { createClient } from './FeatureFlagsClient';

/**
 * Wraps the component with the feature flags client.
 *
 * @returns {function} The wrapped component.
 */
export default function withOpenFeatureConsumer() {
  return function wrap(WrappedComponent) {
    function WithOpenFeatureConsumer(props) {
      const client = useOpenFeatureClient();
      const featureFlagsClient = useMemo(() => createClient(client), [client]);
      return <WrappedComponent {...props} featureFlagsClient={featureFlagsClient} />;
    }
    const name = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    WithOpenFeatureConsumer.displayName = `WithOpenFeatureConsumer(${name})`;
    return WithOpenFeatureConsumer;
  };
}
